import { Language } from './language';

const de = {
    code: Language.de,

	// HOME PAGE
	
	t_description: '{age} Jahre altes Schlagzeugermädchen',
	t_close: 'Schließen',

	b_home: 'Startseite',
	b_about: 'Über mich',
	b_press: 'Presse & Medien',
	b_shows: 'Live-Auftritte',
	b_latest_show: 'Aktuell',
	b_soultone: 'Soultone',
	b_paiste: 'Paiste',
	b_collision: 'Collision',
	b_language: 'Deutsch',
	b_share: 'Aktie',
	b_scroll_to_top: 'Nach oben scrollen',
	b_click: 'Klicken',
	b_tap: 'Tippen',

	t_english: 'Englisch',
	t_spanish: 'Spanisch',
	t_portuguese: 'Portugiesisch',
	t_italian: 'Italienisch',
	t_french: 'Französisch',
	t_german: 'Deutsch',
	t_chinese: 'Chinesisch',

	// SHOWS PAGE

	KRKComeTogether2026DROM_title: 'KRFK Come Together Festival',
	KRKComeTogether2026DROM_description: 'DROM, New York City',

	KRKComeTogether2026Chelsea_title: 'KRFK Come Together Festival',
	KRKComeTogether2026Chelsea_description: 'Chelsea Table & Stage, New York City',

	RockFantasy2026Whisky_title: 'Rock and Roll Fantasy Camp',
	RockFantasy2026Whisky_description: 'The Whisky a Go Go, Hollywood CA.',

	RockFantasy2026Viper_title: 'Rock and Roll Fantasy Camp',
	RockFantasy2026Viper_description: 'The Viper Room, Hollywood CA.',

	FulcrumCelebrationOfLight2026_title: 'Fulcrum Lichtfeier 2026',
	FulcrumCelebrationOfLight2026_description: 'Sheraton Grand Seattle',

	QueenTribute_title: 'Queen-Tribute',
	QueenTribute_description: 'School of Rock Seattle',

	FremontFridays2025_title: 'Fremont Freitags 2025',
	FremontFridays2025_description: 'Fremont Freitags Seattle',

	DrumFantasyCamp2025_title: 'Drum-Fantasy-Camp 2025',
	DrumFantasyCamp2025_description: 'Drum-Fantasy-Camp in Los Angeles',

	ClassicMetal_title: 'Klassisches Metall',
	ClassicMetal_description: 'School of Rock Seattle',

	StAlsGrandDay2024_title: 'Aufführung am Großen Tag 2024',
	StAlsGrandDay2024_description: 'St. Alphonsus Parish School Seattle',

	BlackViolinConcert_title: 'Schwarzes Violinkonzert mit The World Your Orchestra',
	BlackViolinConcert_description: 'Das Paramount Theater',

	MexicanIndependenceDay2024_title: 'Feier zum mexikanischen Unabhängigkeitstag mit dem Ballard Civic Orchestra',
	MexicanIndependenceDay2024_description: 'Rathaus Seattle',

	BluesRock_title: 'Blues Rock',
	BluesRock_description: 'School of Rock Seattle',

	BallardSeaFoodFest2024_title: 'Ballard Seafood Fest 2024',
	BallardSeaFoodFest2024_description: 'Ballard Seafood Fest',

	Funk_title: 'Funk',
	Funk_description: 'School of Rock Seattle',

	Heart_title: 'Heart',
	Heart_description: 'School of Rock Seattle',

	ModernMetal_title: 'Moderner Metal',
	ModernMetal_description: 'School of Rock Seattle',

	SeasonPreviewWinter2023_title: 'Saisonvorschau Winter 2023',
	SeasonPreviewWinter2023_description: 'School of Rock Seattle',

	SmashingPumpkins_title: 'Smashing Pumpkins',
	SmashingPumpkins_description: 'School of Rock Seattle',

	Nirvana_title: 'Nirvana',
	Nirvana_description: 'School of Rock Seattle',

	HairMetal_title: 'Haarmetall',
	HairMetal_description: 'School of Rock Seattle',

	TalentShow2023_title: 'Talentshow 2023',
	TalentShow2023_description: 'Grundschule Seattle Salmon Bay',

	Deftones_title: 'Deftones',
	Deftones_description: 'School of Rock Seattle',

	SeasonPreviewSpring2023_title: 'Saisonvorschau Frühjahr 2023',
	SeasonPreviewSpring2023_description: 'School of Rock Seattle',

	Ramones_title: 'The Ramones',
	Ramones_description: 'School of Rock Seattle',

	Soundtrack_title: 'Soundtrack Show',
	Soundtrack_description: 'School of Rock Seattle',

	PopPunkVsEmo_title: 'Pop Punk Vs. Emo',
	PopPunkVsEmo_description: 'School of Rock Seattle',

	_90sNostalgia_title: 'Nostalgie der 90er Jahre',
	_90sNostalgia_description: 'School of Rock Seattle',

	TalentShow2022_title: 'Talentshow 2022',
	TalentShow2022_description: 'Grundschule Seattle Salmon Bay',
	
	// PRESS PAGE

	b_watch_here: 'Hier ansehen',

	king_5_feature_title: 'Fulcrum / King 5 Bericht',
	king_5_feature_description: 'Seattle King 5 TV-Beitrag, präsentiert von Fulcrum',

	bateristland_title: 'Bateristland Featuring',
	bateristland_description: 'Interview auf dem YouTube-Kanal Bateristland',

	komo_news_title: 'Komo News Bericht',
	komo_news_description: 'Seattle Refined Interview',

	andrew_rooney_drums_title: 'Andrew Rooney Reaktion',
	andrew_rooney_drums_description: 'Andrew Rooney reagiert auf Victorias Performance von Tom Sawyer von Rush',

	upper_lefters_interview_title: 'Upper Lefters Interview',
	upper_lefters_interview_description: 'Interview auf dem YouTube-Kanal Upper Lefters über Victorias Karriere und Zukunftspläne',

	the_eagle_969_title: '96.9 The Eagle Classic Hits Radiosender',
	the_eagle_969_description: '96.9 The Eagle Classic Hits Blogbeitrag über Victorias Rush-Cover',

	fox_13_news_title: 'Fox 13 Seattle News mit',
	fox_13_news_description: 'Wahrer Nordwestabschnitt mit',

	the_daly_migs_show_interview_title: 'Interview mit der Daly Migs Show',
	the_daly_migs_show_interview_description: 'Interview über die Einladung zu Godsmack on Stage',

	alizee_defan_07_02_2024_title: '"Alizee Defan" interview',
	alizee_defan_07_02_2024_description: 'Eksklusivt interview',

	jaime_mendez_news_06_26_2024_title: '"Jaime Mendez Nieuws"-interview',
	jaime_mendez_news_06_26_2024_description: 'Lokaal Seattle-nieuws in het Spaans',

	bien_informado_03_22_2023_title: 'Artikel von "Bien Informado',
	bien_informado_03_22_2023_description: 'Artikel auf der argentinischen Nachrichtenseite über Victoria Drums',

	wave_potter_reaction_01_30_2023_title: 'Wave Potter Reaktion',
	wave_potter_reaction_01_30_2023_description: 'Wave Potter reagiert auf Victorias Cover von Lux Æterna von Metallica',

	// ABOUT PAGE

	b_back: 'Geh zurück',

	t_title: 'Victoria Acosta',
	t_pronouns: '(sie/ihr)',

	b_read_more: 'Mehr lesen',
	b_read_less: 'Weniger anzeigen',
	b_stat_age: 'Alter',
	b_stat_shows: 'Live-Shows',
	b_stat_yrs: 'Jahre Schlagzeug',
	b_stat_awards: 'Auszeichnungen',

	t_about: `
Mit Sticks in der Hand und Rhythmus in der Seele ist die {age}-jährige Victoria Acosta eine der spannendsten jungen Schlagzeugerinnen der Gegenwart. Geboren in El Paso, Texas, aufgewachsen in Guadalajara, Mexiko, und heute in Seattle zu Hause, ist sie für ihre Hingabe, Energie und starke Bühnenpräsenz bekannt.

Victoria begann mit vier Jahren Schlagzeug zu spielen und erhielt am 13. September 2018 ihr erstes Schlagzeug. Sie wurde an der Musicalerias Academy in Guadalajara ausgebildet und setzte ihr Studium in Seattle fort. Nach einer Probestunde bei der School of Rock am 29. Mai 2022 übersprang sie Rock 101 und wurde direkt in das Performers Program aufgenommen. Seitdem trat sie in {shows} Live-Shows auf.

Sie hat hunderte Videos für soziale Medien aufgenommen und wurde am 13. Juni 2024 vom italienischen Komponisten Alberto Rigonni als Gastschlagzeugerin für Nemesis Call eingeladen. Am 12. September 2024 erhielt sie ein Endorsement von Soultone Cymbals und trat am 8. März 2025 dem Künstler-Roster von Collision Drumsticks bei.

Im August 2025 nahm Victoria am Drum Fantasy Camp in Los Angeles teil und lernte bei Dave Weckl, Dennis Chambers, Peter Erskine und Gavin Harrison. Im selben Monat begann sie außerdem, bei dem Schlagzeuglehrer Dave Stark zu lernen, dessen Anleitung weiterhin ihre Technik, Musikalität und ihren künstlerischen Ausdruck prägt.

Am 13. Februar 2026 wurde Victoria Paiste Artist. Im selben Monat nahm sie am Rock and Roll Fantasy Camp teil, jammte mit Nita Strauss, Stewart Copeland, Monte Pittman, Steve Stevens, Skunk Baxter und Leland Sklar und trat im Viper Room und im Whisky a Go Go auf. 2026 gewann sie außerdem das Neil Peart Drum Set Scholarship, das von der Percussive Arts Society und Hudson vergeben wird.

Neben dem Schlagzeug begann Victoria in der vierten Klasse Geige zu lernen und trat 2024 der World Youth Orchestra bei. Sie spielte mit Black Violin im Paramount Theatre und debütierte als Perkussionistin mit dem Ballard Civic Orchestra im Town Hall Seattle bei der Feier zum mexikanischen Unabhängigkeitstag.

Zu ihren Auszeichnungen gehören der Gold Prize und der Fantastic Technique Award beim London Young Musician Contest 2022 sowie der Annual Star Musician Award und der Outstanding Drummer Special Award 2023. Victoria übt täglich und erweitert mit unaufhaltsamem Antrieb und grenzenloser Kreativität ihre Grenzen.
`,

	// PRESS PAGE

	t_footer: 'Alle Rechte vorbehalten',

		// SOULTONE: 

		b_visit_artist_page: 'Besuchen Sie meine Künstlerseite',

}

export default de;
